/* eslint import/prefer-default-export: 0 */
import env from 'config/environment';

export const login = {
  title: 'Welcome to the Questionnaire for\nNational Background Investigation Services',
  error: {
    title: 'Sorry, but we couldn’t log you in!',
    generic: 'The email address or password was incorrect.',
    network: 'Sorry, there was a network error during your attempt to login.',
    unknown: 'Sorry, an unknown error {{status}} occurred.',
    saml: '{{identityProviderName}} SAML initialization failed'
  },
  saml: {
    button: 'Log In With {{identityProviderName}}'
  },
  announcement: {
    title: env.LoginAnnouncementTitle(),
    body: env.LoginAnnouncementBody(),
  },
  basic: {
    button: 'Log In',
    username: {
      label: 'Email Address',
    },
    password: {
      label: 'Password',
    },
    show: {
      title: 'Show password',
      text: 'Show password',
    },
    hide: {
      title: 'Hide password',
      text: 'Hide password',
    },
    forgot: {
      title: 'Forgot password',
      text: 'Forgot password',
    },
  },
  denied: {
    title: 'We could not find your application with the information provided.',
    para: [
      'The email you provided is not associated with an active account.',
      'Contact the National Background Investigation Service help line at (878) 274-5091 between the hours of 0600 and 1700 Eastern Standard Time (EST) or by email at DCSAAKC@mail.mil if you believe this message was received in error, or try logging in again below.',
    ],
    button: 'Log in',
  },
  locked: {
    title: 'Download your documents',
    subtitle: 'You have successfully submitted your {{formName}}. Please note that UTC time was used to record the time of your submission.',
    timeSubmitted: 'Your form was submitted on: {{lastSubmissionDate}}',
    subtitlePending: [
      'We are currently preparing a PDF copy of your completed form. Please stand by it should be available momentarily.',
      'If you continue to see this message, you may try back later or obtain a copy from the organization that sponsored your form.',
    ],
    para: ['If you need assistance contact the office who initiated your form.'],
    expiration: 'This PDF copy will be available until',
    button: 'Back to login',
    formButton: {
      title: 'Completed {{formName}} form',
      buttonText: 'Download your completed {{formName}} form',
    },
    certificates: {
      title: 'Signed certification and releases',
      text:
        'The following are archival documents corresponding to your digitally signed certification and releases',
      buttonText: 'Download',
      certification: {
        title: 'Certification date.pdf',
      },
      credit: {
        title: 'Fair Credit Reporting date.pdf',
      },
      release: {
        title: 'General Release date.pdf',
      },
    },
  },
  token: {
    heading: 'Questionnaire for National Background Investigation Services',
    title: 'For security reasons you have been logged out',
    saved: 'Your data was saved 1 minute prior to logout at {{time}}.',
    para: [
      'This may be due to a slow connection speed and/or inactivity. Please log in again to continue.',
    ],
    button: 'Back to login',
  },
};
